import 'intersection-observer'

const observedElements = {}

function intersectionUpdated (entries) {
  const observedEntries = entries.filter(e => {
    return {}.hasOwnProperty.call(observedElements, e.target.id)
  })
  observedEntries.forEach(e => {
    const observedConfig = observedElements[e.target.id]
    observedConfig.ports.intersecting.send({
      elementId: observedConfig.id,
      isIntersecting: e.isIntersecting
    })
  })
}

const observer = new IntersectionObserver(intersectionUpdated)

function intersectionObserve (ports, id) {
  requestAnimationFrame(() => {
    const e = document.getElementById(id)

    if (e !== null) {
      observedElements[id] = { id, ports }
      observer.observe(e)
    }
  })
}

export default function setupPorts (ports) {
  if (ports.intersectionObserve) {
    ports.intersectionObserve.subscribe((id) => {
      intersectionObserve(ports, id)
    })
  }
}
